import { useQuery } from "@tanstack/react-query";
import { serviceMapService } from "../../services/serviceMapService";
import type { AlertEvent } from "../../types";
import { alertEventsService } from "../../services/alertEventsService";

export const useServiceEvents = (serviceMapId?: string, serviceId?: string) => {
  return useQuery<AlertEvent[]>({
    enabled: Boolean(serviceMapId && serviceId),
    queryKey: ["service-events", serviceMapId, serviceId],
    queryFn: async () => {
      const serviceMap = await serviceMapService.get(serviceMapId!);
      const service = serviceMap.nodes.find((n) => n.id === serviceId);
      const events: AlertEvent[] = [];
      const alertIds = new Set<string>();

      for (const kpi of service?.data.kpis ?? []) {
        for (const alertId of kpi.alerts ?? []) {
          alertIds.add(alertId);
        }
      }

      for (const alertId of alertIds) {
        events.push(...(await alertEventsService.list(alertId)));
      }

      return events;
    },
  });
};
